// extracted by mini-css-extract-plugin
module.exports = {"cell":"CornerCell_cell__1JFQo"};